import React from 'react';

/** Inline SVGs from homepage_prod Advanced solutions; IDs namespaced for the pricing modal. */

export const PricingAdvancedApiArt = () => (
  <svg aria-hidden height={120} viewBox="0 0 320 120" width="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="adv-api-grad-modal" x1="0%" x2="100%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#3aafa9" />
        <stop offset="100%" stopColor="#007888" />
      </linearGradient>
    </defs>
    <circle cx="160" cy="52" fill="url(#adv-api-grad-modal)" opacity="0.35" r="36" />
    <path d="M88 72h144a8 8 0 0 1 8 8v4H80v-4a8 8 0 0 1 8-8z" fill="#007888" opacity="0.2" />
    <rect fill="url(#adv-api-grad-modal)" height="22" opacity="0.85" rx="4" width="40" x="72" y="42" />
    <rect fill="url(#adv-api-grad-modal)" height="22" opacity="0.65" rx="4" width="40" x="140" y="34" />
    <rect fill="url(#adv-api-grad-modal)" height="22" opacity="0.85" rx="4" width="40" x="208" y="42" />
    <path
      d="M112 53h28M180 45h28M248 53h28"
      stroke="#007888"
      strokeLinecap="round"
      strokeOpacity="0.45"
      strokeWidth="2"
    />
    <circle cx="92" cy="53" fill="#fff" r="4" stroke="#007888" strokeWidth="2" />
    <circle cx="160" cy="45" fill="#fff" r="4" stroke="#007888" strokeWidth="2" />
    <circle cx="228" cy="53" fill="#fff" r="4" stroke="#007888" strokeWidth="2" />
  </svg>
);

export const PricingAdvancedEnterpriseArt = () => (
  <svg aria-hidden height={120} viewBox="0 0 320 120" width="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="adv-data-grad-modal" x1="0%" x2="0%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#3aafa9" />
        <stop offset="100%" stopColor="#007888" />
      </linearGradient>
    </defs>
    <rect fill="url(#adv-data-grad-modal)" height="52" opacity="0.35" rx="6" width="180" x="70" y="28" />
    <rect fill="#007888" height="36" opacity="0.55" rx="3" width="22" x="92" y="52" />
    <rect fill="#3aafa9" height="48" opacity="0.75" rx="3" width="22" x="126" y="40" />
    <rect fill="#007888" height="28" opacity="0.45" rx="3" width="22" x="160" y="60" />
    <rect fill="#3aafa9" height="40" opacity="0.65" rx="3" width="22" x="194" y="48" />
    <rect fill="#007888" height="32" opacity="0.5" rx="3" width="22" x="228" y="56" />
    <path d="M70 88h180" stroke="#007888" strokeLinecap="round" strokeOpacity="0.25" strokeWidth="1.5" />
  </svg>
);

export const PricingAdvancedPropertyArt = () => (
  <svg aria-hidden height={120} viewBox="0 0 320 120" width="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="adv-prop-grad-modal" x1="0%" x2="100%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#3aafa9" />
        <stop offset="100%" stopColor="#007888" />
      </linearGradient>
    </defs>
    <rect fill="url(#adv-prop-grad-modal)" height="48" opacity="0.25" rx="6" width="112" x="104" y="30" />
    <path
      d="M120 78V54h80v24"
      fill="none"
      stroke="#007888"
      strokeLinecap="round"
      strokeOpacity="0.5"
      strokeWidth="2"
    />
    <path d="M160 42l-28 12v8h56v-8l-28-12z" fill="url(#adv-prop-grad-modal)" opacity="0.85" />
    <rect fill="#007888" height="6" opacity="0.35" rx="1" width="16" x="152" y="56" />
    <path d="M88 88h144" stroke="#007888" strokeLinecap="round" strokeOpacity="0.2" strokeWidth="1.5" />
    <path
      d="M96 88v-16l12 8 12-10 14 12 16-14 12 10 12-8v18"
      fill="none"
      stroke="#007888"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <circle cx="96" cy="88" fill="#3aafa9" r="3" />
    <circle cx="120" cy="80" fill="#3aafa9" r="3" />
    <circle cx="146" cy="90" fill="#3aafa9" r="3" />
    <circle cx="176" cy="78" fill="#3aafa9" r="3" />
    <circle cx="204" cy="88" fill="#3aafa9" r="3" />
    <circle cx="224" cy="88" fill="#3aafa9" r="3" />
  </svg>
);
